<template>
  <div v-if="((isSuccess && !isConfirmOrder) || isPail) && !close" class="msgbox">
    <div class="shade"></div>
    <div class="msgbox-content">
      <!-- 弹窗内容 -->
      <div class="content-text">
        <!-- 成功 -->
        <div v-if="isSuccess">
          <iconfont class="icon-status iconsuccess" />
          <div>恭喜您！购买成功</div>
        </div>
        <!-- 失败 -->
        <div v-if="isPail">
          <iconfont class="icon-status iconwrong" />
          <div>购买遇到问题了</div>
        </div>
      </div>
      <!-- 操作按钮 -->
      <div class="button-next">
        <span v-if="isSuccess" @click="closeClick">我知道了</span>
        <span v-if="isPail" @click="againClick">重新购买</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PayResultAlert',
  props: {
    isConfirmOrder: Boolean // 是否是订单页
  },
  data() {
    return {
      close: false // 显示错误的
    }
  },
  computed: {
    ...mapGetters('payment/order', [
      'payStatus' // 支付状态
    ]),
    // 再次购买
    buyAgain() {
      return {
        name: 'confirmOrder',
        params: this.$route.params
      }
    },
    isSuccess() {
      return this.payStatus.status === 1
    },
    isPail() {
      return this.payStatus.status === -1
    }
  },
  created() {},
  methods: {
    // 支付成功后，关闭提示
    closeClick() {
      this.close = true
    },
    // 支付失败时，再次购买
    againClick() {
      this.close = true
      // 不是订单页面
      if (!this.isConfirmOrder) {
        this.$router.push(this.buyAgain)
      }
    },
    reset() {
      this.close = false
    }
  }
}
</script>

<style lang="scss" scoped>
// 消息框
.msgbox {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  // 遮罩
  .shade {
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: #000;
  }
  // 内容
  .msgbox-content {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    background-color: #fff;
    width: 85%;
    border-radius: 6px;
    font-size: 16px;
    overflow: hidden;
    transition: 0.2s;
    .content-text {
      font-size: 16px;
      font-weight: bold;
      color: #000;
      padding: 24px;
    }
    .icon-status {
      display: inline-block;
      font-size: 48px;
      margin-bottom: 20px;
      &.iconsuccess {
        color: #00b25a;
      }
      &.iconwrong {
        color: #e65c53;
      }
    }
  }
  .button-next {
    color: #00b25a;
    font-size: 16px;
    font-weight: bold;
    padding: 12px 20px;
    border-top: 1px solid #dddddd;
  }
}
</style>
